<template>
  <el-dialog
    width="1000px"
    :center="true"
    :show-close="true"
    :visible.sync="visiable"
    :close-on-click-modal="false"
    append-to-body
    top="1vh"
  >
    <div slot="title">
      <div style="font-size: 16px">新增项目</div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <el-form
        :model="param"
        :inline="true"
        size="mini"
        style="display: flex; align-items: center"
      >
      <el-form-item label="项目编号">
          <el-input
            v-model="param.projectCode"
            placeholder="请输入..."
            :maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input
            v-model="param.projectName"
            placeholder="请输入..."
            :maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="submitForm()" size="mini"
          >查询</el-button
        >
      </el-form>
    </div>
    <div style=" margin-bottom: 14px">
      
    </div>
    <div class="tableBody">
      <el-table
        v-loading="listLoading"
        class="limitManagerTable table-expand"
        style="width: 100%"
        :data="tableData"
        size="mini"
        border
        header-row-class-name="table-header"
        @selection-change="handleSelectionChange"
      >
        >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          minWidth="200"
          prop="projectCode"
          label="项目编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="projectName"
          minWidth="200"
          label="项目名称"
          align="center"
        ></el-table-column>
        <el-table-column
          width="140"
          prop="startTime"
          label="项目开始日期"
          align="center"
        ></el-table-column>
        <el-table-column
          width="140"
          prop="endTime"
          label="项目结束日期"
          align="center"
        ></el-table-column>
      </el-table>
      <!-- 分页 -->
       <el-pagination
        class="pagination table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="formData.pageSize"
        layout="slot,sizes, total,  prev, pager, next, jumper"
        :total="formData.total"
      >
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visiable = false" size="small">取 消</el-button>
      <el-button
        @click="subAdd()"
        type="primary"
        :disabled="multipleSelection.length === 0"
        size="small"
        >确认添加</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import utils from "@/common/js/util.js";
export default {
  data() {
    return {
      allCustomers: [], //项目列表数组 用于筛选
      keep: [], //项目列表数组 全部用于还原
      multipleSelection: [], //选中项
      param2: {},
      //筛选项参数
      param: {},
          //表单翻页
        formData: {
        projectCode: null,
        projectName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false,
    };
  },
  methods: {
    show(item) {
      this.param = {};
      this.tableData = [];
      this.formData = {
        projectCode: null,
        projectName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      };
      this.multipleSelection = [];
      this.item = item;
      this.visiable = true;
      this.param2 = {};
      this.getData();
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    //提交表单（筛选功能）
    submitForm() {
      //先判断是否选中了项目
      this.param2 = JSON.parse(JSON.stringify(this.param));
      this.getData();
    },
    //获取数据
    getData() {
      this.listLoading = true;
      this.multipleSelection = [];
      let params = {
        id: this.item.id,
        ...this.param2,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo,
      };
      //获取表单数据
      this.$http({
        method: "GET",
        headers: { "content-type": "application/json" },
        url: "/rest/agreementProject/listNoAgreementPro",
        params: params,
      })
        .then((res) => {
          this.tableData = res.data.items;
          this.formData.total = res.data.totalItemsCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //确认添加
    async subAdd() {
      //先查询 选中的项目有所属其他月份的项目与其他合同客户是否关联
      this.tosubAdd();
    },
    tosubAdd() {
      var projectCodesString = this.multipleSelection.map((el) => {  
        return el.projectCode;  
      }).join(',');
        console.log("multipleSelection projectCodesString:" + projectCodesString);
      this.$http({
        method: "GET",
        url: "/rest/agreementProject/relatedProject",
        headers: { "content-type": "application/json" },
        params: {
          operatorId: sessionStorage.getItem("sysUserId"),
          id: this.item.id,
          projectCode: projectCodesString
        },
      })
        .then((res) => {
          if (res.data.status && res.data.status != 200) {
            this.myNotify(this, "error", res.data.message);
            return;
          }
          this.$emit("done");
          // this.visiable = false;
          this.tableData = [];
          this.param = {};
          this.myNotify(this, "success", "添加成功");
          this.getData();
        })
        .catch(() => {
          this.myNotify(this, "error", "请求失败，请稍后重试");
        });
    },
        //翻页
    handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },
  },
};
</script>
  <style lang="scss" scoped>
.tableBody {
  min-height: 425px;
}
.el-form-item--mini.el-form-item {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/configCanage/agreeProject/Add.vue